// ComprehensiveSpecialtyCareSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import comprehensiveSpecialtyCareImage from '../assets/comprehensive-specialty-care-image.jpg';

const ComprehensiveSpecialtyCareSection = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left Content */}
          <div>
            <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
              Specialty Care
            </p>
            <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
              Comprehensive Specialty Care for Every Stage of Life
            </h2>

            <div className="space-y-4 text-muted text-base leading-relaxed mb-10">
              <p>
                At Wei Care, our specialty care supports people living with particular health challenges and ongoing medical needs. We know every condition calls for a personalised approach, whether that means recovering after a hospital stay, living with a disability, or managing a long-term illness. Our carers provide focused, in-home support that encourages independence, comfort, and confidence, giving families peace of mind that their loved one is receiving attentive, professional care.
              </p>

              <p>
                Our specialty care programmes include hospital-to-home transition support, disability care, Parkinson's care, and chronic condition management. Each service is tailored to the individual's medical and emotional needs, ensuring continuity of care and improved quality of life. From medication reminders and mobility support to companionship and daily living assistance, we help make each day safer, more manageable, and more fulfilling for our clients.
              </p>
            </div>

            <a
              href="tel:+61480804640"
              className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
            >
              <Phone size={18} />
              Call +61 420 162 243
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={comprehensiveSpecialtyCareImage}
              alt="Carer with an older woman outdoors"
              className="w-full h-[420px] lg:h-[560px] rounded-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComprehensiveSpecialtyCareSection;
